import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from '@/hooks/useUserRole';
import { LoadingSpinner } from '@/components/LoadingSpinner';

/**
 * Route guard for admin-only pages (/admin/users, /admin/settings, etc.).
 * More restrictive than AdminGuardedRoute which allows content_manager + partner.
 * Redirects non-admins to the admin dashboard (which they can access).
 */
export const AdminOnlyRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { data: roleData, isLoading } = useUserRole();

  if (isLoading) {
    return (
      <div className="flex flex-col min-h-[50vh]">
        <div className="flex-1 flex items-center justify-center">
          <LoadingSpinner className="h-8 w-8" />
        </div>
      </div>
    );
  }

  if (!roleData?.isAdmin) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{children}</>;
};
